export { default } from '../../src/pages/Company'
